import React from 'react';
import propTypes from 'prop-types';

/**
 * centered heading for the carrier resources state grid, with the optional
 * State Based Exchange / Marketplace legend on the right.
 * @param title - heading text (the carrier name)
 * @param showLegend - whether to render the SBE/marketplace legend
 */
export default function SbeGridHeader({ title, showLegend }) {
  return (
    <div className='flex justify-between items-center mb-5 lg:grid lg:grid-cols-[1fr_auto_1fr]'>
      <h3 className='text-3xl font-bold text-gray-700 m-0 lg:col-start-2 lg:text-center'>
        {title}
      </h3>
      {showLegend && (
        <div className='flex flex-col items-end lg:mr-10'>
          <div className='flex flex-col gap-0.5 text-xs lg:text-md text-gray-500'>
            <span className='flex items-center gap-1.5'>
              <span className='w-2.5 h-2.5 rounded-full bg-[#9ad7fa] inline-block shrink-0' />
              <span>State Based Exchange</span>
            </span>
            <span className='flex items-center gap-1.5'>
              <span className='w-2.5 h-2.5 rounded-full bg-[#0056a3] inline-block shrink-0' />
              <span>Marketplace</span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

SbeGridHeader.propTypes = {
  title: propTypes.string,
  showLegend: propTypes.bool
};
